import React, { useState, useRef } from 'react';
import axios from 'axios';

export default function Write() {
  const [formData, setFormData] = useState({
    title: '',
    content: '',
    url: '', 
    category1: '0', 
  });

  const fileInputRef = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // 입력 필드 변경 핸들러
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log('=== 폼 제출 시작 ===');
    console.log('현재 formData:', formData);

    // 유효성 검사 강화
    if (!formData.title || !formData.title.trim()) {
      console.error('제목 검증 실패:', formData.title);
      alert('제목을 입력해주세요.');
      return;
    }

    if (!formData.content || !formData.content.trim()) {
      console.error('내용 검증 실패:', formData.content);
      alert('내용을 입력해주세요.');
      return;
    }

    setIsSubmitting(true);

    try {
      const formDataForSubmit = new FormData();

      // FormData에 데이터 추가
      formDataForSubmit.append('title', formData.title.trim());
      formDataForSubmit.append('content', formData.content.trim());
      formDataForSubmit.append('url', formData.url ? formData.url.trim() : ''); 
      formDataForSubmit.append('category1', formData.category1);

      // 파일 처리
      if (fileInputRef.current && fileInputRef.current.files[0]) {
        const file = fileInputRef.current.files[0];
        console.log('선택된 파일:', {
          name: file.name,
          size: file.size,
          type: file.type
        });
        
        // 파일 크기 검증 (5MB 제한)
        if (file.size > 5 * 1024 * 1024) {
          alert('파일 크기는 5MB를 초과할 수 없습니다.');
          setIsSubmitting(false);
          return;
        }
        
        formDataForSubmit.append('file', file); 
      } else {
        console.log('선택된 파일 없음');
      }

      // FormData 내용 확인
      console.log('=== 전송할 FormData 내용 ===');
      for (let pair of formDataForSubmit.entries()) {
        if (pair[1] instanceof File) {
          console.log(`${pair[0]}: [File] ${pair[1].name} (${pair[1].size} bytes)`);
        } else {
          console.log(`${pair[0]}: ${pair[1]}`);
        }
      }

      console.log('API 요청 시작...');
      
      const response = await axios.post(
        '/api/admin/insertEvent',
        formDataForSubmit,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          timeout: 30000, // 30초 타임아웃 추가
        }
      );

      console.log('=== API 응답 ===');
      console.log('응답 상태:', response.status);
      console.log('응답 데이터:', response.data);

      // 응답 구조 상세 확인
      if (response.data) {
        console.log('response.data.success:', response.data.success);
        console.log('response.data.message:', response.data.message);
        
        if (response.data.success === true) {
          alert('이벤트가 성공적으로 등록되었습니다.');
          console.log('등록 성공, 페이지 이동 중...');
          window.location.href = '/admin/event';
        } else {
          const errorMessage = response.data.message || '이벤트 등록에 실패했습니다.';
          console.error('등록 실패:', errorMessage);
          alert(errorMessage);
        }
      } else {
        console.error('응답 데이터가 없습니다:', response);
        alert('서버 응답이 올바르지 않습니다.');
      }
    } catch (error) {
      console.error('=== 에러 발생 ===');
      console.error('에러 객체:', error);
      
      if (error.response) {
        // 서버가 응답했지만 에러 상태 코드
        console.error('응답 상태:', error.response.status);
        console.error('응답 헤더:', error.response.headers);
        console.error('응답 데이터:', error.response.data);
        
        if (error.response.status === 413) {
          alert('파일 크기가 너무 큽니다. 더 작은 파일을 선택해주세요.');
        } else if (error.response.status === 500) {
          alert('서버 내부 오류가 발생했습니다. 관리자에게 문의해주세요.');
        } else {
          alert(`서버 오류 (${error.response.status}): ${error.response.data?.message || '알 수 없는 오류'}`);
        }
      } else if (error.request) {
        // 요청은 보냈지만 응답을 받지 못함
        console.error('요청 객체:', error.request);
        alert('서버에 연결할 수 없습니다. 네트워크 상태를 확인해주세요.');
      } else {
        // 요청 설정 중 에러
        console.error('에러 메시지:', error.message);
        alert('요청 처리 중 오류가 발생했습니다.');
      }
    } finally {
      setIsSubmitting(false);
      console.log('=== 폼 제출 완료 ===');
    }
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="titleNav">이벤트/소식 등록</div>
        <div className="wrap">
          <div className="over_hi" style={{ marginTop: '60px' }}>
            <form onSubmit={handleSubmit} encType="multipart/form-data">
              <table className="adminTable">
                <tbody>
                  <tr>
                    <th style={{ width: '200px' }}>카테고리</th>
                    <td className="left">
                      <div>
                        <label style={{ marginRight: '20px' }}>
                          <input
                            type="radio"
                            name="category1"
                            value="0"
                            checked={formData.category1 === '0'}
                            onChange={handleChange}
                            style={{ marginRight: '5px' }}
                          />
                          크림봇 EVENT
                        </label>
                        <label>
                          <input
                            type="radio"
                            name="category1"
                            value="1"
                            checked={formData.category1 === '1'}
                            onChange={handleChange}
                            style={{ marginRight: '5px' }}
                          />
                          뉴스/소식
                        </label>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th style={{ width: '200px' }}>제목</th>
                    <td className="left">
                      <input
                        type="text"
                        name="title"
                        id="title"
                        value={formData.title}
                        onChange={handleChange}
                        style={{ width: '100%', padding: '8px' }}
                        placeholder="이벤트 제목을 입력하세요"
                        required
                      />
                    </td>
                  </tr>
                  <tr>
                    <th style={{ width: '200px' }}>내용</th>
                    <td className="left">
                      <textarea
                        name="content"
                        id="content"
                        style={{ 
                          width: '100%', 
                          height: '300px', 
                          padding: '8px',
                          resize: 'vertical',
                          fontFamily: 'inherit'
                        }}
                        value={formData.content}
                        onChange={handleChange}
                        placeholder="이벤트 내용을 입력하세요"
                        required
                      ></textarea>
                    </td>
                  </tr>
                  <tr>
                    <th style={{ width: '200px' }}>유투브 URL</th>
                    <td className="left">
                      <input
                        type="url"
                        name="url"
                        id="url"
                        value={formData.url}
                        onChange={handleChange}
                        style={{ width: '100%', padding: '8px' }}
                        placeholder="유투브 링크를 입력해주세요."
                      />
                    </td>
                  </tr>
                  <tr>
                    <th style={{ width: '200px' }}>
                      첨부파일<br />(~5MB)
                    </th>
                    <td className="left">
                      <input
                        type="file"
                        name="file"
                        id="file"
                        ref={fileInputRef}
                        accept="image/*,.pdf,.doc,.docx,.hwp,.txt"
                      />
                      <small style={{ color: '#666', marginLeft: '10px' }}>
                        (최대 5MB)
                      </small>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="right" style={{ marginTop: '20px' }}>
                <button
                  type="button"
                  className="common-del"
                  onClick={() => (window.location.href = '/admin/event')}
                  style={{ marginRight: '10px' }}
                >
                  목록으로
                </button>
                <button
                  type="submit"
                  className="common-del"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? '등록 중...' : '등록하기'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}